import { ShieldCheck } from 'lucide-react';

export function OrgCompliancePage() {
  return (
    <div className="space-y-4">
      <h1 className="text-2xl">Compliance</h1>
      <div className="rounded-lg border bg-card p-6 flex gap-4">
        <ShieldCheck className="size-8 text-muted-foreground shrink-0 mt-0.5" />
        <div>
          <p className="font-medium">Compliance is managed at the property level.</p>
          <p className="text-sm text-muted-foreground mt-1">
            Visit each property's dashboard to view DSAR requests and trigger data retention sweeps.
            Org-level compliance aggregation is a future feature.
          </p>
        </div>
      </div>
    </div>
  );
}
